/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Read-only access to ConsultantGroups.
 */
export const consultantsListResponseOwnerOneUsernameMax = 150;


export const consultantsListResponseOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const consultantsListResponseOwnerOneEmailMax = 254;

export const consultantsListResponseOwnerOnePhoneNumberMax = 128;

export const consultantsListResponseConsultantsItemUsernameMax = 150;


export const consultantsListResponseConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const consultantsListResponseConsultantsItemEmailMax = 254;

export const consultantsListResponseConsultantsItemPhoneNumberMax = 128;

export const consultantsListResponseFileRegExp = new RegExp('(?:jpg|png|jpeg)$');


export const ConsultantsListResponseItem = zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(consultantsListResponseOwnerOneUsernameMax).regex(consultantsListResponseOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(consultantsListResponseOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(consultantsListResponseOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(consultantsListResponseConsultantsItemUsernameMax).regex(consultantsListResponseConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(consultantsListResponseConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(consultantsListResponseConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(consultantsListResponseFileRegExp).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const ConsultantsListResponse = zod.array(ConsultantsListResponseItem)

/**
 * Read-only access to ConsultantGroups.
 */
export const ConsultantsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this consultant group.')
})

export const consultantsRetrieveResponseOwnerOneUsernameMax = 150;


export const consultantsRetrieveResponseOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const consultantsRetrieveResponseOwnerOneEmailMax = 254;

export const consultantsRetrieveResponseOwnerOnePhoneNumberMax = 128;

export const consultantsRetrieveResponseConsultantsItemUsernameMax = 150;


export const consultantsRetrieveResponseConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const consultantsRetrieveResponseConsultantsItemEmailMax = 254;

export const consultantsRetrieveResponseConsultantsItemPhoneNumberMax = 128;

export const consultantsRetrieveResponseFileRegExp = new RegExp('(?:jpg|png|jpeg)$');


export const ConsultantsRetrieveResponse = zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(consultantsRetrieveResponseOwnerOneUsernameMax).regex(consultantsRetrieveResponseOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(consultantsRetrieveResponseOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(consultantsRetrieveResponseOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(consultantsRetrieveResponseConsultantsItemUsernameMax).regex(consultantsRetrieveResponseConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(consultantsRetrieveResponseConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(consultantsRetrieveResponseConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(consultantsRetrieveResponseFileRegExp).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Retrieve a ConsultantGroup by its ID.
 *
 * This is a public endpoint that returns basic information about a consultant group.
 * Used to support frontend functionality that needs to display consultant group data
 * without requiring authentication.
 */
export const ConsultantsByIdRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this consultant group.')
})

export const consultantsByIdRetrieveResponseOwnerOneUsernameMax = 150;


export const consultantsByIdRetrieveResponseOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const consultantsByIdRetrieveResponseOwnerOneEmailMax = 254;

export const consultantsByIdRetrieveResponseOwnerOnePhoneNumberMax = 128;

export const consultantsByIdRetrieveResponseConsultantsItemUsernameMax = 150;


export const consultantsByIdRetrieveResponseConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const consultantsByIdRetrieveResponseConsultantsItemEmailMax = 254;

export const consultantsByIdRetrieveResponseConsultantsItemPhoneNumberMax = 128;

export const consultantsByIdRetrieveResponseFileRegExp = new RegExp('(?:jpg|png|jpeg)$');


export const ConsultantsByIdRetrieveResponse = zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(consultantsByIdRetrieveResponseOwnerOneUsernameMax).regex(consultantsByIdRetrieveResponseOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(consultantsByIdRetrieveResponseOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(consultantsByIdRetrieveResponseOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(consultantsByIdRetrieveResponseConsultantsItemUsernameMax).regex(consultantsByIdRetrieveResponseConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(consultantsByIdRetrieveResponseConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(consultantsByIdRetrieveResponseConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(consultantsByIdRetrieveResponseFileRegExp).nullish()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Get all customer accounts for the authenticated consultant
 *
 * Only consultant users can access this endpoint.
 */
export const ConsultantsCustomerAccountsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const ConsultantsCustomerAccountsListResponse = zod.array(ConsultantsCustomerAccountsListResponseItem)

